import { timeMinutes } from 'd3-time';
import { DateTime, Duration } from 'luxon';

export default ({
    height,
    ticks,
    timeStepsPerDay,
    startTime,
    endTime,
    timezone,
    fontSize,
    width,
    xScale,
    yScale,
    highlightedTimelineGroupHeight,
    onMaxLabelHeightXChange,
    onMaxLabelHeightYChange,
    onMaxLabelWidthYChange,
}) => {
    const timeStepsPerDayInHours = 24 / timeStepsPerDay;
    const xHourTickValues = timeMinutes(startTime.startOf('day').valueOf(), endTime.valueOf(), timeStepsPerDayInHours * 60);
    const xDayMiddayTickValues = timeMinutes(startTime.startOf('day').plus(Duration.fromISO('PT12H')).valueOf(), endTime.valueOf(), 24 * 60);
    const xDayMidnightTickValues = timeMinutes(startTime.startOf('day').valueOf(), endTime.valueOf(), 24 * 60);

    const xAxisBaseProps = {
        height,
        scale: xScale,
        orient: 'Bottom',
        fontSize,
        ticks,
        width,
    };
    const fontSizeScale = fontSize / 100;

    return {
        getDaysXAxisProps: ({ maxLabelHeightX }) => {
            return {
                ...xAxisBaseProps,
                translate: `translate(0, ${maxLabelHeightX + height + highlightedTimelineGroupHeight})`,
                tickValues: xDayMiddayTickValues,
                className: 'daysAxisLabel',
                tickSizeOuter: [24 * fontSizeScale],
                tickSizeInner: [6 * fontSizeScale],
                tickFormat: (val) => {
                    return DateTime.fromJSDate(val, { zone: timezone }).toFormat('ccc dd');
                },
            };
        },
        getDaysMidnightXAxisProps: ({ maxLabelHeightX }) => {
            return {
                ...xAxisBaseProps,
                translate: `translate(0, ${maxLabelHeightX + height + highlightedTimelineGroupHeight})`,
                tickValues: xDayMidnightTickValues,
                className: 'daysMidnightAxisLabel',
                tickSizeInner: [25 * fontSizeScale],
                tickFormat: () => {
                    return '';
                },
            };
        },
        getTimeXAxisProps: () => {
            return {
                ...xAxisBaseProps,
                translate: `translate(0, ${height + highlightedTimelineGroupHeight})`,
                tickValues: xHourTickValues,
                tickSizeOuter: [40 * fontSizeScale],
                className: 'timesAxis',
                tickFormat: (val) => {
                    return DateTime.fromJSDate(val, { zone: timezone }).toFormat('HH:mm');
                },
                maxLabelHeight: onMaxLabelHeightXChange,
            };
        },
        getValuesYAxisProps: ({ maxLabelHeightY }) => {
            return {
                height,
                scale: yScale,
                orient: 'Left',
                translate: `translate(0, 0)`,
                ticks: Math.floor(height / maxLabelHeightY),
                fontSize,
                width,
                maxLabelWidth: onMaxLabelWidthYChange,
                maxLabelHeight: onMaxLabelHeightYChange,
            };
        },
    };
};
